(function () {
    angular.module('tmx-app')
        .controller('lookupManagementEditCtrl', ['$stateParams', '$state', '$mdDialog', '$filter', 'resolvedData', 'tmxUtility', 'TmxDialogService', 'ToastService','LookupManagementService','lookupService',
            function lookupManagementEditCtrl($stateParams, $state, $mdDialog, $filter, resolvedData, tmxUtility, TmxDialogService,ToastService,LookupManagementService,lookupService) {

                //#region  ========= Variable Initialization ========================
                var lookupEditVM = this;
                var localeList = [];
                var lookupNameList = [];
                var allLookupList = [];
                var sortOrderLastLookup = 0;
                lookupEditVM.checkPermission = tmxUtility.checkPermission;
                lookupEditVM.addEnabled = false;
                lookupEditVM.readonly = false; // Can set this property according to state, this is already handled in UI

                lookupEditVM.vm = {};
                lookupEditVM.vm.LookupName = $stateParams.Id;
                lookupEditVM.vm.currentLookupList = [];
                //#endregion

                //#region ========= Scope functions ==================================
                lookupEditVM.showAdditionalParametersScreen = function (lookup, index) {
                    var metaDataLovs = {};
                    metaDataLovs.statusLookup = lookupEditVM.statusLookup;
                    metaDataLovs.localeList = localeList;
                    metaDataLovs.lookupNameList = lookupNameList;
                    metaDataLovs.allLookups = resolvedData.AllLookups;
                    metaDataLovs.allLookupList = allLookupList;
                    $mdDialog.show({
                        controller: ['$mdDialog', '$scope', '$filter', 'ToastService', 'tmxUtility', 'data', 'lovs', lookupDetailsController],
                        locals: {
                            data: lookup,
                            lovs: metaDataLovs
                        },
                        templateUrl: 'app/private/masterdata/lookup-management/lookup-details-dialog.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        fullscreen: true
                    }).then(function (returnData) { // After closing the dialog
                        if (tmxUtility.exists(returnData)) {
                            lookupEditVM.vm.currentLookupList[index] = returnData;
                        }
                    });

                }

                lookupEditVM.addLookup = function () {
                    let lookup = {
                        LookupId: 0,
                        LookupType: lookupEditVM.vm.LookupName,
                        SortOrder: ++sortOrderLastLookup,
                        UserEditable: 1
                    };
                    lookupEditVM.vm.currentLookupList.push(lookup);
                    tmxUtility.gotoAnchor('VisibleValuerow'+(lookupEditVM.vm.currentLookupList.length-1));
                }

                lookupEditVM.removeLookup = function (index) {
                    lookupEditVM.vm.currentLookupList.splice(index, 1);
                }

                lookupEditVM.cancel = function () {
                    if (!lookupEditVM.dialogForm.$dirty) {
                        $state.go("^", {}, { reload: true });
                        return;
                    }
                    $state.searchClear = true;
                    TmxDialogService.showConfirmDialog($filter('translate')("Confirm"), $filter('translate')("DiscardChangesConfirm"), function () {
                        $state.go("^", {}, { reload: true });
                    });
                }

                lookupEditVM.save = function (form) {
                    if (!CheckFormValidity(form)) {
                        ToastService.showCustomToast("error", $filter('translate')("CorrectInvalidFields"));
                        return;
                    }
                    LookupManagementService.updateLookups(lookupEditVM.vm.currentLookupList).then(onUpdateLookup);

                    function onUpdateLookup(response){
                        if(tmxUtility.exists(response,"status")){
                            if(response.status.code == 200){
                                ToastService.showCustomToast("success",$filter('translate')("DataSaveSuccess"));
                                $state.searchClear = true;
                                $state.go("^", {}, { reload: true });
                                lookupService.clearLocalLookups();
                                return;
                            }
                        }
                        ToastService.showCustomToast("error",$filter('translate')("SaveError"));

                    }
                }

                //#endregion


                //#region ========= Local functions =================================

                function SetFormState() {
                    lookupEditVM.addEnabled = lookupEditVM.checkPermission('Private.Masterdata.LookupManagement', 'Create');
                }
                function HandleResolveData() {
                    if (tmxUtility.exists(resolvedData.Lookups)) {
                        lookupEditVM.vm.currentLookupList = tmxUtility.orderArrayByProperty(resolvedData.Lookups.data, ['IsActive', 'SortOrder', 'VisibleValue'], ['desc', 'asc', 'asc']);
                        sortOrderLastLookup = Math.max(...lookupEditVM.vm.currentLookupList.map(x => x.SortOrder || 0));
                    }
                    if (tmxUtility.exists(resolvedData.Locales, 'data')) {
                        localeList = resolvedData.Locales.data.map(x => ({ LookupId: x.LocaleId, VisibleValue: x.Language }));
                    }
                    if (tmxUtility.exists(resolvedData.AllGroupedLookups, 'lookups.names')) {
                        lookupNameList = resolvedData.AllGroupedLookups.lookups.names.map(x => ({ HiddenValue: x, VisibleValue: x }));
                    }
                    if (tmxUtility.exists(resolvedData.AllLookups)) {
                        Object.keys(resolvedData.AllLookups).forEach(key => {
                            allLookupList.push(resolvedData.AllLookups[key])
                        });
                    }
                }
                function InitializeData() {
                    lookupEditVM.statusLookup = [
                        {
                            LookupId: '1',
                            VisibleValue: 'Active'
                        },
                        {
                            LookupId: '0',
                            VisibleValue: 'Inactive'
                        }
                    ];
                }

                function SetTouched(form) {
                    angular.forEach(form, function (value) {
                        if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)) {
                            value.$setTouched();
                        }
                    });
                }

                function CheckFormValidity(form) {
                    if (form.$invalid) {
                        SetTouched(form);
                        return false;
                    }
                    return true;
                }
                //#endregion


                //#region ========= Child Controllers ================================

                function lookupDetailsController($mdDialog, $scope, $filter, ToastService, tmxUtility, data, lovs) {
                    $scope.originalLookup = data;
                    $scope.lookup = angular.copy(data); // To edit in the copy
                    $scope.metaDataLovs = lovs;
                    $scope.readonly = false;
                    $scope.parentLookupList = [];
                    var parentLookup = null;
                    var allLookupList = lovs.allLookupList;

                    (function InitializeDataForDialog() {
                        // set the parent type
                        if (tmxUtility.exists($scope.lookup.ParentLookupId) && $scope.lookup.ParentLookupId > 0) {
                            parentLookup = lovs.allLookups[$scope.lookup.ParentLookupId];
                            if (tmxUtility.exists(parentLookup)) {
                                $scope.lookup.ParentType = parentLookup.LookupType;
                            }
                            $scope.parentLookupList = filterLookupByType($scope.lookup.ParentType);
                        }
                    })();

                    function filterLookupByType(type) {
                        //allLookupList only contains active lookups so we need to filter by type
                        return allLookupList.filter(x => x.LookupType == type);
                    }

                    $scope.OnParentTypeSelected = function (selectedType) {
                        if (!tmxUtility.exists(selectedType)) {
                            $scope.lookup.ParentLookupId = null;
                            $scope.parentLookupList = [];
                            return;
                        }
                        $scope.parentLookupList = filterLookupByType(selectedType);
                    }

                    $scope.cancel = function () {
                        $mdDialog.hide();
                    }

                    $scope.ok = function () {
                        $scope.lookupDetailsCtrl.dialogForm.$submitted = true;
                        if (!$scope.lookupDetailsCtrl.dialogForm.$valid) {
                            ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                            return;
                        }
                        $scope.originalLookup = $scope.lookup;
                        $mdDialog.hide($scope.originalLookup);
                    }

                }

                //#endregion

                (function InitializePage() {
                    SetFormState();
                    HandleResolveData();
                    InitializeData();
                })();
            }]);
})();

